module.exports = __webpack_public_path__ + "static/media/waiting-for-vote.963309e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/waiting-for-vote.png
// module id = 335
// module chunks = 0